import type { IMessageGifPayload } from 'Models/MessageModel';

export function normalizeGifPayload(
  gif?: { id?: unknown }
): IMessageGifPayload | undefined {
  const rawId = gif?.id;
  if (rawId === undefined || rawId === null) {
    return undefined;
  }

  const id = String(rawId).trim();

  if (!id) {
    return undefined;
  }

  return { id };
}
